export const constant = {
	storagePrefix: 'feedbackMessengerDraft',
	intentStorageKey: 'feedbackMessengerDraftIntent',
	ttlMs: 30 * 24 * 60 * 60 * 1000,
	saveDebounceMs: 2000,
	maxDraftLength: 2_000_000,
	selector: {
		form: '.feedback-messenger-window',
		scopeAttribute: 'data-clm-draft-scope',
		typeAttribute: 'data-clm-draft-type',
		templateIdAttribute: 'data-clm-template-id',
		restoredMessageAttribute: 'data-clm-draft-restored-message',
		requiredSubjectPartAttribute: 'data-clm-required-subject-part',
		restoredMarkerAttribute: 'data-clm-draft-restored',
		boundMarkerAttribute: 'data-clm-draft-bound',
		subjectInput: 'input[name="subject"]',
		contentTextarea: 'textarea[name="content"]',
		continueButton: 'data-clm-draft-continue',
		continueTime: 'data-clm-draft-continue-time',
		discardButton: 'data-clm-draft-discard',
		banner: 'data-clm-draft-banner',
		bannerContinue: 'data-clm-draft-banner-continue',
		bannerFresh: 'data-clm-draft-banner-fresh',
		templateSelect: 'select[name="template"]',
	},
}
